import Event from '../../core/Event';

export default class EstimationsImportFailed extends Event {
    public static type = 'EstimationsImportFailed';

    constructor(public readonly errors: string[]) {
        super(EstimationsImportFailed.type);
    }
}



// WEBPACK FOOTER //
// ./src/application/estimations/events/EstimationsImportFailed.ts